import {toArray} from 'lodash';
import axios from 'axios';

export default class TagOverlay {

  constructor(el) {
    this.el = el;
    this.overlay = el.closest('[id^="tc-tag-overlay"]');
    this.triggerButton = document.querySelector(`[href="#${this.overlay.id}"]`);
    this.form = this.el.querySelector('.tc-tag-overlay__form');
    this.restartButton = this.el.querySelector('.tc-tag-overlay__restart');
    this.closeButton = this.el.querySelector('.tc-close-overlay');
    this.initialPage = this.el.querySelector('.tc-tag-overlay__initial');
    this.thankyouPage = this.el.querySelector('.tc-tag-overlay__thankyou');

    if (this.form) {
      this.form.addEventListener('submit', this.submitForm.bind(this), false);
    }
    if (this.form) {
      this.restartButton.addEventListener('click', this.restartForm.bind(this), false);
    }
    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.restartForm.bind(this), false);
    }
  }

  restartForm(e) {
    if (this.form) {
      this.form.reset();
      this.initialPage.style.display = '';
      this.thankyouPage.style.display = '';
    }
  }

  submitForm(e) {
    const form = e.target;
    const initialPage = this.el.querySelector('.tc-tag-overlay__initial');
    const thankyouPage = this.el.querySelector('.tc-tag-overlay__thankyou');

    if (window.tcLoader) {
      window.tcLoader.setActive(true);
    }

    axios({
      method: 'post',
      url: form.action,
      data: new FormData(form),
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(res => {
        if (res.data.success) {
          initialPage.style.display = 'none';
          thankyouPage.style.display = 'block';

          if (window.tcLoader) {
            window.tcLoader.setInactive(true);
          }

          if (res.data.pornstar) {
            const span = document.createElement('span');
            span.className = 'tc-tag-overlay__suggested-tag';
            span.textContent = res.data.pornstar;
            this.triggerButton.parentNode.insertBefore(span, this.triggerButton);
          }
        }
      })
      .catch(error => {
        initialPage.style.display = 'none';
        thankyouPage.style.display = 'block';

        if (window.tcLoader) {
          window.tcLoader.setInactive(true);
        }

        throw `TagOverlay.js, axios fetch failed: ${error.message} in ${error.fileName}:${error.LineNumber}`;
      });

    e.preventDefault();
  }
}
